import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=bcdf3bbc&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=bcdf3bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdf3bbc",
  null
  
)

export default component.exports